
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Fade from '@mui/material/Fade';
import Topbar from '../Topbar/Topbar';

interface IProps {
  children: ReactNode;
}

const rootStyle = 
  css`
    display: flex;
  `;



const contentStyle = 
  css`
    flex-grow: 1;
    height: 100vh;    
    padding-bottom: ${mikeSharedTheme.spacing(0)}; 
    padding-left: ${mikeSharedTheme.spacing(0)}; 
    padding-right: ${mikeSharedTheme.spacing(0)}; 
    padding-top: ${mikeSharedTheme.spacing(7.5)}; 
    background-color: ${mikeSharedTheme.palette.lightGrey?.main};  
    overflow: auto;
  `;

function AppLayout(props: IProps) {
 
  const { children } = props
  
  return (   
    <>
     <CssBaseline />
     <Fade in>
      <div css={rootStyle}>       
        <Topbar />
        <main css={contentStyle}>
          {children}
        </main>      
      </div>
      </Fade>
    </>
  )
}

export default AppLayout
